"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

export default function AgeGate() {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    setMounted(true);
    try {
      if (!localStorage.getItem("cellbloxk_age_verified")) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  if (!mounted) return null;
  if (!visible) return null;

  const enter = () => {
    if (!agreed) return;
    try { localStorage.setItem("cellbloxk_age_verified", "true"); } catch {}
    setVisible(false);
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-start justify-center bg-black/97 backdrop-blur-lg overflow-y-auto py-12 px-4">
      <div className="max-w-lg w-full mx-4 rounded-2xl bg-[#0a0a0a] border border-white/[0.06] shadow-[0_0_80px_rgba(0,0,0,0.8)] relative overflow-hidden">

        {/* Top red stripe */}
        <div className="h-1 bg-red-600" />

        <div className="px-6 md:px-8 py-8">

          {/* Logo — full width */}
          <div className="text-center mb-6 mt-4">
            <div className="text-[48px] md:text-[56px] font-black tracking-[0.03em] text-white leading-none" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
              CELL<span className="text-red-500">BLOXK</span>
            </div>
            <div className="text-[18px] md:text-[21px] font-black tracking-[0.82em] text-red-500 uppercase leading-none mt-[2px]" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
              BARBIE
            </div>
          </div>

          {/* RTA Badge */}
          <div className="flex justify-center mb-6 mt-4">
            <span className="text-[10px] font-black text-neutral-400 border border-neutral-700 bg-neutral-900/80 px-3 py-1.5 rounded tracking-[0.15em]">RTA RESTRICTED TO ADULTS</span>
          </div>

          {/* Main heading */}
          <h1 className="text-center text-xl md:text-2xl font-black uppercase tracking-wider text-white mb-2">
            Age Verification Required
          </h1>
          <p className="text-center text-[12px] text-neutral-400 mb-6 leading-relaxed max-w-sm mx-auto">
            This website contains sexually explicit material including imagery, video, and audio of nude adults and adult content creators.
          </p>

          {/* Legal notice box */}
          <div className="bg-black/40 border border-white/[0.04] rounded-xl p-4 mb-6 space-y-3 text-[11px] text-neutral-500 leading-relaxed">
            <p>
              By entering this website, you acknowledge and agree that:
            </p>
            <p>
              <span className="text-white font-bold">1.</span> You are at least <span className="text-white font-bold">18 years of age</span> (or the age of legal majority in your jurisdiction, whichever is greater).
            </p>
            <p>
              <span className="text-white font-bold">2.</span> You have read, understand, and agree to be bound by our <Link href="/legal/terms" className="text-red-400 underline underline-offset-2" target="_blank">Terms of Service</Link> and <Link href="/legal/privacy" className="text-red-400 underline underline-offset-2" target="_blank">Privacy Policy</Link>.
            </p>
            <p>
              <span className="text-white font-bold">3.</span> You understand that this website contains <span className="text-white font-bold">sexually explicit content</span> intended exclusively for adults, and that viewing such material is legal in your jurisdiction.
            </p>
            <p>
              <span className="text-white font-bold">4.</span> You will not permit any minor to access this website or any content contained herein.
            </p>
            <p>
              <span className="text-white font-bold">5.</span> You understand that all content on this platform is provided by independent content creators and is maintained in compliance with <span className="text-white font-bold">18 U.S.C. 2257</span> record-keeping requirements. Our <Link href="/legal/2257" className="text-red-400 underline underline-offset-2" target="_blank">2257 compliance statement</Link> is available for review.
            </p>
            <p>
              <span className="text-white font-bold">6.</span> You voluntarily choose to access this content and release CellBloxk Barbie, its operators, and SupaMane Technologies LLC from any liability arising from your use of this website.
            </p>
          </div>

          {/* Checkbox */}
          <label className="flex items-start gap-3 mb-6 cursor-pointer group">
            <div className="mt-0.5 shrink-0">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                className="sr-only"
              />
              <div className={`w-5 h-5 rounded border-2 flex items-start justify-center transition-all ${
                agreed
                  ? "bg-red-600 border-red-600"
                  : "border-neutral-600 group-hover:border-neutral-400"
              }`}>
                {agreed && (
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
            </div>
            <span className="text-[11px] text-neutral-400 leading-relaxed">
              I confirm that I am at least 18 years old, I have read and agree to the Terms of Service and Privacy Policy, and I consent to viewing sexually explicit material.
            </span>
          </label>

          {/* Buttons */}
          <div className="flex flex-col gap-2.5">
            <button
              onClick={enter}
              disabled={!agreed}
              className={`w-full rounded-xl py-3.5 text-sm font-black uppercase tracking-[0.15em] transition-all ${
                agreed
                  ? "bg-red-600 hover:bg-red-500 text-white shadow-[0_0_20px_rgba(220,38,38,0.3)]"
                  : "bg-neutral-800 text-neutral-600 cursor-not-allowed"
              }`}
            >
              I Am 18+ -- Enter
            </button>
            <button
              onClick={() => { window.location.href = "https://www.google.com"; }}
              className="w-full rounded-xl py-3 text-[12px] font-medium text-neutral-500 border border-white/[0.06] hover:bg-white/[0.03] transition"
            >
              I Am Under 18 -- Exit
            </button>
          </div>

          {/* Bottom fine print */}
          <div className="mt-6 pt-4 border-t border-white/[0.04] text-center">
            <p className="text-[9px] text-neutral-700 font-mono uppercase tracking-widest leading-relaxed">
              This site is operated by SupaMane Technologies LLC<br />
              18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement on file<br />
              All performers were 18 years of age or older at the time of content creation
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
